<script>
import dialog2Mixin from "../mixins/dialog2";
import formatDate from '@utils/format-date'
import isCondition from "@utils/is-condition";
import { authComputed } from '@store/helpers'
import { getStoreOption} from "@utils/ipetbooking-options";
import { getDefaultReservationDisabledDayList } from "@utils/ipetbooking-get-default";
import _debounce from "lodash/debounce";
import { reservationTimeList } from "@utils/ipetbooking-reservation";
import getISODay from "date-fns/getISODay";
import parseISO from "date-fns/parseISO";
import lastDayOfMonth from 'date-fns/lastDayOfMonth'
import isThisMonth from 'date-fns/isThisMonth'
import isThisYear from 'date-fns/isThisYear'

export default {
  name:'DialogScheduleItemServiceTime1',
  components: {
    InputRadioTime: () => import("@components/Input/InputRadioTime"),
  },
  mixins: [dialog2Mixin],
  data() {
    return {
      scheduleItem: {},
      reservationItemTimes: [],
      defaultValue: {},
      startDate: '',
      endDate: '',
      currentDisabledDate: [],
      type: '',
      serviceType: 'cosmetic',
      callbackChangeSchedule: () => {},

    }
  },
  computed: {
    ...authComputed,
    storeItem() {
      return getStoreOption({
        value: this.defaultValue.storeAlias,
        type: 'item'
      })
    },
    buttonBarList() {
      const buttonBarList = [
        {
          text: this.formatMobileSubmitText,
          class: "flex-grow-1",
          buttonClass: "isStylePrimary isRadius isSmall isFull",
          isLoading: this.loading,
          isDisabled: this.invalid,
          onClick: () => {
            this.onSubmit()
          },
        }
      ];

      return buttonBarList.filter(item => {
        return isCondition(item)
      })
    },
    timeList() {
      return reservationTimeList({
        date: this.defaultValue?.date,
        storeAlias: this.storeItem.alias,
        times: this.reservationItemTimes,
        storeType: this.storeItem.storeType
      })
    },
  },
  watch: {
    startDate: {
      immediate: true,
      handler(newValue, oldValue) {
        this.tryToFetchReservationCalendar()
      }
    },
    '$route.name': {
      handler: function(search) {
        if (search !== this.type) {
          this.dialog2MixinVisible = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {

  },
  methods: {
    formatDate,
    getDefaultReservationDisabledDayList,
    onSubmit() {
      const submitData = {
        date: this.defaultValue.date,
        scheduleItemId: this.scheduleItem.id,
        time: this.defaultValue.time,
        scheduleItems: this.scheduleItem
      }
      this.callbackChangeSchedule(submitData)
      this.$Dialog2MixinOnDestroy();
    },
    onChangeDate: _debounce(function(item) {
      if(!this.defaultValue.date) return
      this.tryToFetchReservationItem();
    }, 300),

    tryToFetchReservationItem() {
      this.$store.dispatch('merchant/fetchReservationItem', {
        reservationAlias: this.defaultValue.reservationAlias,
        date: formatDate(this.defaultValue.date, 'yyyy-MM-dd'),
        prepaidOrderUuid: this.defaultValue.prepaidOrderUuid,
        scheduleItemId: this.scheduleItem.id,
        types: [this.serviceType]
      })
        .then(({ items }) => {
          const setReservationItemTimes = () => {
            const timesInfo = Object.keys(items.timesInfo).length ? Object.keys(items.timesInfo).filter((item) => {
              return items.timesInfo[item].canTimeOrder
            }): []
            this.reservationItemTimes = timesInfo
            this.reservationScheduleItems = items.timesInfo;
            this.checkOnlyOneTimesAutoFocus();
          };

          setReservationItemTimes();
          this.checkTimeInReservationItemTimes();
        })
    },

    checkTimeInReservationItemTimes() {
      const isIncludesTimes = this.reservationItemTimes.includes(this.defaultValue.time);

      if(!isIncludesTimes) {
        this.defaultValue.time = ''
      }
    },
    checkOnlyOneTimesAutoFocus() {
      if(this.timeList.length === 1) {
        this.defaultValue.time = this.timeList[0]
      }
    },
    onChangeTime() {
      // this.replaceHistory();
    },
    onChangePage: _debounce(function(page) {
      this.formatCalendarRangeDate(page);
    }, 300),
    formatCalendarRangeDate(page) {
      const date = new Date(page.year,(page.month - 1))
      const isThisCurrentYear = isThisYear(date)
      const isThisCurrentMonth = isThisMonth(date)
      if(isThisCurrentYear && isThisCurrentMonth) {
        this.startDate =  formatDate(new Date(), 'yyyy-MM-dd');
        this.endDate = formatDate(lastDayOfMonth(new Date()), 'yyyy-MM-dd')
      } else {
        this.startDate = formatDate(date, 'yyyy-MM-dd');
        this.endDate = formatDate(lastDayOfMonth(date), 'yyyy-MM-dd')
      }
    },
    tryToFetchReservationCalendar() {
      
      if(!this.startDate && !this.endDate) {
        return
      }
      const submitData = {
        startDate: this.startDate,
        endDate: this.endDate,
        priceAlias: this.defaultValue.reservationAlias,
        scheduleItemId: this.scheduleItem.id,
        types: [this.serviceType]
      }
      // this.$nextTick(() => {
        this.$store.dispatch('merchant/fetchReservationCalendar', {
          ...submitData
        })
          .then(({ items }) => {
            const currentDisabledDate = Object.keys(items).length ? Object.keys(items).filter((item) => {
              return !items[item].isOpen
            }): []
            this.currentDisabledDate = currentDisabledDate.length ? currentDisabledDate.map((item) => {
              return parseISO(item)
            }) : []
          })
    },
  }
}
</script>
<!-- section template -->
<template>
  <el-dialog
    :visible.sync="dialog2MixinVisible"
    width="˙786px"
    append-to-body
    :custom-class="`${ $style.dialogScheduleItemServiceTime } isStyleBase`"
    @closed="$Dialog2MixinOnDestroy"
  >
    <div class="dialogScheduleItemServiceTime__title mb-4">預定其他日期與時段</div>
    <div class="dialogScheduleItemServiceTime__content">
      <span class="text-primary">美容師{{ scheduleItem.name }}</span>
      <br>其他預約可日期與時段
    </div>
    <!-- <div id="time" style="position: relative; top: -6rem"></div> -->
    <v-date-picker
      ref="dialogScheduleDate"
      v-model="defaultValue.date"
      v-loading="$isLoading('fetchReservationCalendar')"
      class="isStyleBase"
      :class="{ 'isStyleDingBeauty': $globalIsDingBeauty }"
      :min-date="new Date()"
      :disabled-dates="[
        { 
          weekdays: getDefaultReservationDisabledDayList({ storeAlias: defaultValue.storeAlias, prepaidId: defaultValue.prepaidOrderUuid, type: 'v-date-picker' }),
        },
        ...currentDisabledDate,
      ]"
      is-expanded
      :masks='{ title: "YYYY年 MM月" }'
      :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }"
      @update:from-page="onChangePage"
      @input="onChangeDate"
    >
    </v-date-picker>
    <el-skeleton
      :loading="$isLoading('fetchReservationItem')"
      animated
      :throttle="0"
      style="margin-bottom: 3rem;"
    >
      <template slot="template">
        <div
          class="row"
          :class="$style.skeletonList"
        >
          <div
            v-for="n in 16"
            :key="n"
            class="col-3 skeletonList__item"
          >
            <el-skeleton-item
              class="skeletonList__button"
              variant="rect"
            />
          </div>
        </div>
      </template>
      <template>
        <template v-if="!defaultValue.date">
          <span style="padding-bottom: 30px">
           *請選擇時間
          </span>
        </template>
        <template v-else-if="timeList.length === 0">
        <span style="padding-bottom: 30px">
          *無時段可供預約，請選擇其他日期
        </span>
        </template>
        <template v-else>
          <InputRadioTime
            v-model="defaultValue.time"
            :time-list="timeList"
            :display="16"
            @click="onChangeTime"
          />
        </template>
      </template>
    </el-skeleton>
    <BaseButton
      :disabled="!defaultValue.time || !defaultValue.date"
      class="isStylePrimary isFull isRadius mb-3"
      @click="onSubmit"
    >
      確認
    </BaseButton>
    <BaseButton
      class="isStyleDark isOutline3 isRadius isFull"
      @click="dialog2MixinVisible = false"
    >
      取消
    </BaseButton>
  </el-dialog>
</template>
<!-- section style -->
<style lang="scss" module>
.dialogScheduleItemServiceTime {
  :global {
    .dialogScheduleItemServiceTime {
      &__title {
        margin-bottom: 1.5rem;
        font-family:$font-title;
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 1.5;
        color: $color-primary-dark;
        text-align: center;
      }

      &__content {
        font-size: 0.875rem;
        line-height: 2;
        color: $color-gray-2;
        text-align: center; 
      }
    }
  }
}
</style>
